export const info = [
    {
        label: '运输单号',
        prop: 'ettaNo'
    },
    {
        label: '客户订单号',
        prop: 'ettaSoNo'
    },
    {
        label: '装车排序',
        prop: 'loadingSeq'
    },
    {
        label: '合同编号',
        prop: 'ettaContractNo'
    },
    {
        label: '天猫预约单号',
        prop: 'ettaLbxNo'
    },
    {
        label: '客户',
        prop: 'ettaCustomEbcuNameCn'
    },
    {
        label: '线路',
        prop: 'ettaEblnLineName'
    },
    {
        label: '装货仓库',
        prop: 'ettaOutWhName'
    },
    {
        label: '收货单位',
        prop: 'ettaConsigneeEbspNameCn'
    },
    {
        label: '收货地址',
        prop: 'ettaToEbrgAddress'
    },
    {
        label: '体积',
        prop: 'ettaVolume'
    },
    {
        label: '重量',
        prop: 'ettaWeight'
    },
    {
        label: '数量',
        prop: 'ettaQuantity'
    },
    {
        label: '紧急程度',
        prop: 'ettaLevel'
    },
    {
        label: '要求发运时间',
        prop: 'ettaLatestShipmentDate'
    },
    {
        label: '集拼号',
        prop: 'ettaAssighNo'
    },
    {
        label: '要求到货时间',
        prop: 'ettaDemandAogDate'
    },
    {
        label: '到车时间',
        prop: 'ettaArriveDate'
    },
    {
        label: '装货时间',
        prop: 'ettaLoadingDate'
    },
    {
        label: '是否预约',
        prop: 'ettaReservation'
    },
    {
        label: '客户预约单号',
        prop: 'ettaReservationNo'
    },
    {
        label: '预约送货时间',
        prop: 'ettaReservationTime'
    },
    {
        label: '终端收货单位',
        prop: 'eoorConsigneeName'
    },
    {
        label: '终端收货市',
        prop: 'eoorConsigneeCityName'
    },
    {
        label: '终端收货区县',
        prop: 'eoorConsigneeDistrictName'
    },
    {
        label: '上游集拼号',
        prop: 'cimsVampNo'
    },
    {
        label: '订单备注',
        prop: 'ettaRemark'
    }
];
export const inventory = [
    {
        label: '运输单号',
        prop: 'ettmEttkNo'
    },
    {
        label: '商品名称',
        prop: 'ettmEbmaNameCn'
    },
    {
        label: '商品编码',
        prop: 'ettmMaterialNo'
    },
    {
        label: '包装规格',
        prop: 'ettmEbtpPackageType'
    },
    {
        label: '单位',
        prop: 'ettmEbtpPackage'
    },
    {
        label: '单台体积',
        prop: 'ettmPackageVolumn'
    },
    {
        label: '单台重量',
        prop: 'ettmPackageGrossWeight'
    },
    {
        label: '数量',
        prop: 'ettmQuantity'
    },
    {
        label: '体积',
        prop: 'ettmVolume'
    },
    {
        label: '重量',
        prop: 'ettmGrossWeight'
    },
    {
        label: '是否温控',
        prop: 'ettmIsTemperature'
    },
    {
        label: '最低温度',
        prop: 'ettmMinTemperature'
    },
    {
        label: '最高温度',
        prop: 'ettmMaxTemperature'
    },
    {
        label: '最低湿度',
        prop: 'ettmMinHumidity'
    },
    {
        label: '最高湿度',
        prop: 'ettmMaxHumidity'
    },
    {
        label: '合同编号',
        prop: 'ettmTransportContract'
    }
];
